import { observable, action, makeObservable } from 'mobx';

import agent from '../agent';

class TimeBankStore {
    constructor() {
        makeObservable(this, {
            currentMemberTimeBankList: observable,
            currentMemberList: observable,
            currentEntity: observable,
            loading: observable,
            requestParams: observable,
            lastListLoadTime: observable,
            filters: observable,
            appliedFilters: observable,
            currentMemberTotals: observable,

            setFilter: action,
            onFilter: action,
            resetLastListLoadTime: action,
            loadTimeBankMember: action,
            loadTimeBankList: action,
            getPendingTimelogs: action,
            saveTimeBank: action,
            saveHoursToCompOff: action,
            saveToIntegration: action,
            desyncIntegration: action,
            resetCompOffToTimeBank: action,
            remove: action
        });
    }

    currentMemberTimeBankList = {};
    currentMemberList = {};
    currentMemberTotals = {};
    currentEntity = {};
    loading = false;
    requestParams = null;
    lastListLoadTime = null;

    filters = {
        currentUserTimeBankList: '',
    };
    appliedFilters = {
        currentUserTimeBankList: '',
    };

    setFilter(name, value) {
        const filters = Object.assign({}, this.filters);
        filters[name] = value;
        this.filters = filters;
    }

    onFilter() {
        this.appliedFilters = Object.assign({}, this.filters);
    }

    resetLastListLoadTime() {
        this.lastListLoadTime = new Date();
    }

    loadTimeBankMember(params) {
        return agent.TimeBank.loadTimeBankMember(params)
            .then(
                action(list => {
                    this.currentMemberList = list.timeBankMembers;
                    return list.timeBankMembers;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    loadTimeBankList(params = {}, cb) {
        let _params = { ...params };
        if (!_params?.filters?.currentUserTimeBankList)
            _params.filters = this.filters
        return agent.TimeBank.loadTimeBankList(_params)
            .then(
                action(list => {
                    this.requestParams = _params;
                    this.currentMemberTimeBankList = list.rows;
                    this.currentMemberTotals = list.flexitimeTotals;
                    cb();
                    return list;
                })
            )
            .catch(
                action(err => {
                    // this.loading = false;
                    throw err;
                })
            );
    }

    getPendingTimelogs(params = {}) {
        let _params = { ...params };
        if (!_params?.filters?.currentUserTimeBankList)
            _params.filters = this.filters
        return agent.TimeBank.getPendingTimelogs(_params)
            .then(
                action(list => {
                    return list;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveTimeBank(params = {}) {
        return agent.TimeBank.saveTimeBank(params)
            .then(
                action(entity => {
                    return entity;
                })
            )
            .catch(
                action(err => {
                    throw err;
                })
            );
    }

    saveHoursToCompOff(data) {
        this.loading = true;
        return agent.TimeBank.saveHoursToCompOff(data)
            .then(
                action(data => {
                    this.loading = false;
                    return data;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    saveToIntegration(data) {
        this.loading = true;
        return agent.TimeBank.saveToIntegration(data)
            .then(
                action(data => {
                    this.loading = false;
                    return data;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    desyncIntegration(data) {
        this.loading = true;
        return agent.TimeBank.desyncIntegration(data)
            .then(
                action(data => {
                    this.loading = false;
                    return data;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    resetCompOffToTimeBank(data) {
        this.loading = true;
        return agent.TimeBank.resetCompOffToTimeBank(data)
            .then(
                action(data => {
                    this.loading = false;
                    return data;
                })
            )
            .catch(
                action(err => {
                    this.loading = false;
                    throw err;
                })
            );
    }

    async remove(data) {
        const res = await agent.TimeBank.remove(data);
        this.deleteSuccess = true;
        return res;
    }
}



const _TimeBankStore = new TimeBankStore();
export default _TimeBankStore;
